import { useIsMobile } from '@cp/ds/src/hooks/useIsMobile';
import { Box } from '@cp/ds/src/components/box';
import { Container } from '@cp/ds/src/components/container';
import { IconButton } from '@cp/ds/src/components/iconButton';
import { Link } from '@cp/ds/src/components/link';
import { Typography } from '@cp/ds/src/components/typography';
import { OkIcon } from '@cp/ds/src/icons/social/ok';
import { VkIcon } from '@cp/ds/src/icons/social/vk';
import { InstagramIcon } from '@cp/ds/src/icons/social/instagram';
import { YoutubeIcon } from '@cp/ds/src/icons/social/youtube';
import React from 'react';
import { Stack } from '@cp/ds/src/components/stack';
import { StyledListItem } from '@cp/ds/src/components/styled/styledListItem';
import { StyledUnorderedList } from '@cp/ds/src/components/styled/styledUnorderedList';
import { useIsLoggedIn } from '@cp/entities/currentUser';
import loadable from '@loadable/component';
import { WIDTH_QR_CODE_SECTION } from '../const';

const MobileAppLinks = loadable(() => import('src/entities/mobileApp/links'));

export const FooterBottom = () => {
  const isMobile = useIsMobile();
  const loggedIn = useIsLoggedIn();

  return (
    <Box sx={{ backgroundColor: 'gray middle', color: 'text.primary', zIndex: 1, pb: isMobile && loggedIn ? 10 : 0 }}>
      <Container>
        <Stack direction="row" sx={{ width: 1, m: '0 auto', justifyContent: 'space-between', py: 2.25 }}>
          <Stack alignItems="center" direction="row" flexWrap="wrap">
            <Typography component="h5" sx={{ my: 0, mr: 2 }} variant="body bold">
              Присоединяйтесь{!isMobile && ' к нам'}:
            </Typography>
            <Stack component={StyledUnorderedList} direction="row" spacing={2}>
              <StyledListItem>
                <Link external href="https://vk.com/youhelpru" underline={false}>
                  <IconButton color="gray dark" sx={{ borderColor: 'brand gray' }} variant="secondary">
                    <VkIcon title="ВКонтакте" titleAccess="ВКонтакте" />
                    <Typography component="span" sx={{ visibility: 'hidden', position: 'absolute' }}>
                      ВКонтакте
                    </Typography>
                  </IconButton>
                </Link>
              </StyledListItem>
              <StyledListItem>
                <Link external href="https://www.instagram.com/youhelp.ru" underline={false}>
                  <IconButton color="gray dark" sx={{ borderColor: 'brand gray' }} variant="secondary">
                    <InstagramIcon title="Инстаграм" titleAccess="Инстаграм" />
                    <Typography component="span" sx={{ visibility: 'hidden', position: 'absolute' }}>
                      Инстаграм
                    </Typography>
                  </IconButton>
                </Link>
              </StyledListItem>
              <StyledListItem>
                <Link external href="https://ok.ru/group/58024651784263" underline={false}>
                  <IconButton color="gray dark" sx={{ borderColor: 'brand gray' }} variant="secondary">
                    <OkIcon title="Одноклассники" titleAccess="Одноклассники" />
                    <Typography component="span" sx={{ visibility: 'hidden', position: 'absolute' }}>
                      Одноклассники
                    </Typography>
                  </IconButton>
                </Link>
              </StyledListItem>
              <StyledListItem>
                <Link external href="https://www.youtube.com/channel/UCSBSIORfT1aKyOu--_DuY3w" underline={false}>
                  <IconButton color="gray dark" sx={{ borderColor: 'brand gray' }} variant="secondary">
                    <YoutubeIcon title="YouTube" titleAccess="YouTube" />
                    <Typography component="span" sx={{ visibility: 'hidden', position: 'absolute' }}>
                      YouTube
                    </Typography>
                  </IconButton>
                </Link>
              </StyledListItem>
            </Stack>
          </Stack>
          {!isMobile && <MobileAppLinks width={{ xs: 1, md: WIDTH_QR_CODE_SECTION }} />}
        </Stack>
      </Container>
    </Box>
  );
};
